// ---------------------------------------------------------------------------
// Data
// ---------------------------------------------------------------------------

export interface ScatterPlotPoint {
  readonly x: number;
  readonly y: number;
}

// ---------------------------------------------------------------------------
// Params
// ---------------------------------------------------------------------------

export interface ScatterPlotParams {
  readonly points: ScatterPlotPoint[];
  readonly xLabel: string;
  readonly yLabel: string;
}

// ---------------------------------------------------------------------------
// Display
// ---------------------------------------------------------------------------

export interface ScatterPlotDisplayConfig {
  readonly showRegressionLine?: boolean;
  readonly showCorrelation?: boolean;
  readonly showResiduals?: boolean;
  readonly dataZoomX?: boolean;
  readonly dataZoomY?: boolean;
  readonly dotColor?: string;
  readonly dotSize?: number;
  readonly regressionLineColor?: string;
  readonly residualColor?: string;
}

export const DEFAULT_SCATTER_PLOT_DISPLAY: ScatterPlotDisplayConfig = {
  showRegressionLine: true,
  showCorrelation: true,
  showResiduals: false,
  dotColor: '#0ea5e9', // sky-500
  dotSize: 10,
  regressionLineColor: '#8b5cf6', // violet-500
  residualColor: '#ef4444', // red-500
};

// ---------------------------------------------------------------------------
// Prediction
// ---------------------------------------------------------------------------

export interface ScatterPlotPrediction {
  readonly x: number;
  readonly y: number;
}
